// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"382":"hy","884":"admin"}[chunkId] + "." + {"382":"3d5d51bd","884":"6e187b12"}[chunkId] + ".css";
};